import styled from 'styled-components'
import {
  alignItems,
  AlignItemsProps,
  flexDirection,
  FlexDirectionProps,
} from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { Button } from 'Components/UI'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = (prop: string | number) => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps & AlignItemsProps>`
  display: flex;
  gap: ${themeGet('space.11')}px;

  ${flexDirection}
  ${alignItems}
`

export const StyledLink = styled(Button).attrs({
  as: 'a',
})`
  width: 48px;
  height: 48px;
  color: ${themeGet('colors.text.invertedTitle')};
  border-color: ${themeGet('colors.border.slight')};
  padding: 0;

  > svg {
    width: 16px;
    height: 16px;
  }

  &:hover {
    color: ${themeGet('colors.text.invertedTitle')};
    border-color: ${themeGet('colors.border.default')};
  }
`
